import React, { useEffect, useState } from "react";
import Access_ControlActions from "../../../Actions/Access_ControlActions";
import Access_ControlConstants from "../../../Constants/Access_ControlConstants";
import access_ControlStore from "../../../Stores/Access_ControlStores";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../../Context/LanguageContext";
import { useNavigate, useLocation } from "react-router-dom";

import {
  useChildInfoContext,
  useSelectedFunContext,
} from "../../../Context/GlobalContext";
import CustomDataGrid from "../../ReusableComponent/DataGrid/CustomizeDataGrid";
import { GridActionsCellItem } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import { AiOutlineDelete } from "react-icons/ai";
import { Button, Typography } from "@mui/material";
import UserManagementActions from "../../../Actions/UserManagementActions";
import usermanagementStore from "../../../Stores/UsermanagementStore";
import UsermanagementConstants from "../../../Constants/UsermanagementConstants";
import { toast } from "react-toastify";

function Responsibilities(props) {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const location = useLocation();
  const { anlageid, isFunctionCall, handleTourGuid } = props;

  const [tableData, settableData] = useState([]);
  const columns = [
    {
      field: "firstName",
      headerName: localization.firstName,
      hideable: false,
      flex: 1,
    },
    // {
    //   field: "actions",
    //   type: "actions",
    //   width: 45,
    //   hideable: false,
    //   getActions: (params) => [...getAction(params, localization)],
    // },
    {
      field: "surName",
      headerName: localization.surname,
      hideable: false,
      flex: 1,
    },
    {
      field: "username",
      headerName: localization.userName,
      hideable: false,
      flex: 1,
    },
    {
      field: "email",
      headerName: localization.email,
      hideable: false,
      flex: 1,
    },
  ];

  const getEquipmentGroupResponsibleUsers = () => {
    setGlobalSpinner(true);
    UserManagementActions.getEquipmentGroupResponsibleUsers(
      sessionStorage.getItem("eqGId"),
    );
  };

  useEffect(() => {
    getEquipmentGroupResponsibleUsers();

    function getResponsibleUserSuccess() {
      const res = usermanagementStore.getResponsibleUserList();
      if (res) {
        settableData(res);
        setGlobalSpinner(false);
      }
      handleTourGuid(7);
    }

    function getResponsibleUserFailure() {
      var res = usermanagementStore.getResponsibleUserList();
      toast.error(res);
      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_EQUIP_GRP_RESPONSIBLE_USER_SUCCESS,
      getResponsibleUserSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_EQUIP_GRP_RESPONSIBLE_USER_FAILURE,
      getResponsibleUserFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_EQUIP_GRP_RESPONSIBLE_USER_SUCCESS,
        getResponsibleUserSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_EQUIP_GRP_RESPONSIBLE_USER_FAILURE,
        getResponsibleUserFailure,
      );
    };
  }, []);

  function RenderAddHersteller() {
    return (
      <>
        <Button
          id="adduser"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<AddIcon />}
          data-toggle="modal"
          data-target="#addResForm"
          onClick={() => {}}
        >
          {localization.addResponsibleUser}
        </Button>
      </>
    );
  }

  function RenderDeleteButton() {
    return (
      <>
        <Button
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<AiOutlineDelete />}
        >
          {localization.delete}
        </Button>
      </>
    );
  }
  const handleAdd = () => {
    // setHerstellerDetails("");
  };

  function getAction(params) {
    const _acionList = [];
    _acionList.push(
      <GridActionsCellItem
        label={localization.delete}
        showInMenu
        onClick={() => {}}
      />,
    );

    return _acionList;
  }

  const operations = {
    GridToolBarAction: [],
    SelectedToolBar: [
      {
        label: "Delete",
        component: <RenderDeleteButton />,
        onClick: () => {},
      },
    ],
  };

  return (
    <>
      <div className="container-fluid equipDetailContainer p-5 mt-3">
        <div className="row justifyContentSpaceBetw">
          <div className="">
            <Typography gutterBottom variant="h4" component="div">
              {localization.responsibilities}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {localization.responsibilitiesDescInfo}
            </Typography>
          </div>
        </div>
        <div className="ResponsibilityList">
          <CustomDataGrid
            columns={columns}
            rows={tableData}
            operations={operations}
            onAdd={handleAdd}
            showExport={true}
            showColumns={true}
            showFilters={true}
            showDensity={true}
            visibleColumns={[]}
            showCheckBox={false}
            gridTableHeight={"dataGridResponsibility"}
          />
        </div>
      </div>
    </>
  );
}
export default Responsibilities;
